var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"ma-0 pa-0"},_vm._l((_vm.tweets),function(tweet){return _c('TweetCard',{key:tweet.id,attrs:{"initial-tweet":tweet},on:{"after-delete-like":_vm.afterDeleteLike}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }